import { Input, Button, useCustomForm, ArrowPathIcon } from "@";
import { resendAllSchema, resendAllDefaultValues } from "../utils/validation";

const ResendMultiMessages = ({ sendMulti, isSmsBalanceLow, dataLength }) => {
  const { register, watch, handleSubmit, errors, setValue, isSubmitting } =
    useCustomForm(resendAllDefaultValues, resendAllSchema);

  return (
    <>
      {/* A button to open the resend all messages dropdown */}
      <button
        type="button"
        className="btn-green"
        data-dropdown-toggle="resendAll"
        disabled={isSmsBalanceLow || dataLength === 0}
      >
        <ArrowPathIcon className="me-1.5 h-5 w-5" />
        إعادة ارسال
      </button>

      {/* The resend all messages dropdown */}
      <div
        id="resendAll"
        className="z-10 hidden w-80 rounded-2xl border border-gray-200 bg-white shadow-md dark:border-gray-600 dark:bg-gray-800 lg:w-96"
      >
        {/* The form to select the date range */}
        <form className="p-3" onSubmit={handleSubmit(sendMulti)}>
          <Input
            star
            type="date-range"
            labelA="من تاريخ"
            labelB="الي تاريخ"
            valueA={watch("fromDate")}
            valueB={watch("toDate")}
            inputA={register("fromDate")}
            inputB={register("toDate")}
            errorA={errors.fromDate}
            errorB={errors.toDate}
            changeA={(e) => setValue("fromDate", e)}
            changeB={(e) => setValue("toDate", e)}
          />

          {/* The submit button */}
          <Button
            title="ارسال"
            type="submit"
            className="mt-3 w-full"
            isLoading={isSubmitting}
            disabled={isSubmitting}
          />
        </form>
        <p className="px-5 pb-4 text-center text-base text-gray-600 dark:text-gray-400 sm:px-16">
          سوف يتم إعادة ارسال الرسائل التي لم يتم ارسالها في الفترة المحددة
        </p>
      </div>
    </>
  );
};

export default ResendMultiMessages;
